

import Vue from 'vue'
import App from './App'
import router from './router'
import './permission' 
import "swiper/swiper-bundle.min.css"
import VueLazyload from "vue-lazyload";


import store from './store'
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
import Alert from 'vux/src/components/alert/index.vue'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'

import { List } from 'vant';

import Vconsole from 'vconsole'

Vue.config.productionTip = false
Vue.use(List)
Vue.use(Alert)
Vue.use(ToastPlugin)
Vue.use(ConfirmPlugin)
Vue.use(AlertPlugin)
Vue.use(VueLazyload, {
preLoad: 1.3,

loading: './static/images/lazyload.png',
attempt: 1
})


var sensors = require('sa-sdk-javascript');
sensors.init({

server_url: 'https://sa.reflower.com.cn:4006/sa?project=production',
is_track_single_page:true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
use_client_time:true,
send_type:'beacon',
show_log:true,
heatmap: {

clickmap:'default',

scroll_notice_map:'not_collect'
}
});
sensors.quick('autoTrack'); 

Vue.prototype.$sensors = sensors;

Vue.directive('title', {//单个修改标题
inserted: function (el, binding) {
document.title = el.dataset.title
}
})
process.env.NODE_ENV === 'test' ? new Vconsole() : ''
/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
components: { App },
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js